jQuery(function ($) {
  var console = window.console;

  var is_mobile = "No";
  var otvoren = "True";
  var visinaB = $("body").height();
  var sirinaB = $("body").width();
  var visinaW = $(window).height();
  var sirinaW = $(window).width();
  let pozicijaX; // Globalno deklarirane varijable // Pozicija kursora kad se dogodi klik
  let pozicijaY;
  var xP = 0;
  var yP = 0;

  // Jasno odvojeno mjerenje plutajućih kontaktnih i zakonskih akcija.
  // Nazivi ne sadrže osobne podatke i pojavljuju se kao custom events u Clarityju.
  function trackBofAction(eventName) {
    if (typeof window.clarity === "function") {
      window.clarity("event", eventName);
    }
  }

  $(document)
    .off("click.bofFloatingActions")
    .on("click.bofFloatingActions", ".wa__btn_popup", function () {
      var trigger = this;

      window.setTimeout(function () {
        var isOpen = trigger.classList.contains("wa__active");
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");

        if (isOpen) {
          trackBofAction("whatsapp_widget_open");
        }
      }, 0);
    })
    .on(
      "click.bofFloatingActions",
      'a[href*="api.whatsapp.com"], a[href*="wa.me"], .wa__stt',
      function () {
        trackBofAction("whatsapp_chat_start");
      }
    )
    .on(
      "click.bofFloatingActions",
      'a[href*="facebook.com/BeautyofFreya"], a[href*="facebook.com/Beautyoffreya"]',
      function () {
        trackBofAction("facebook_click");
      }
    )
    .on("click.bofFloatingActions", ".exru-btn", function () {
      trackBofAction("contract_termination_click");
    });

  var whatsappPopup = document.querySelector(".wa__btn_popup");

  if (whatsappPopup) {
    var documentLanguage = (document.documentElement.lang || "hr").toLowerCase();
    var whatsappLabels = {
      hr: "Kontaktirajte nas putem WhatsAppa",
      en: "Contact us on WhatsApp",
      de: "Kontaktieren Sie uns über WhatsApp",
    };
    var languageCode = documentLanguage.split("-")[0];

    whatsappPopup.setAttribute("role", "button");
    whatsappPopup.setAttribute("tabindex", "0");
    whatsappPopup.setAttribute(
      "aria-label",
      whatsappLabels[languageCode] || whatsappLabels.hr
    );
    whatsappPopup.setAttribute("aria-expanded", "false");

    whatsappPopup.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        whatsappPopup.click();
      }
    });
  }


// Za pozicioniranje putem vh - oduzima visinu nevidljivog djela ekrana

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


// Za pozicioniranje putem vh - oduzima visinu nevidljivog djela ekrana


  // $(window).load( function(){

  // 	console.log("Širina:" + sirina);
  // 	console.log("Visina:" + visina);
  // });

  // console.log("Širina:" + sirina);
  // console.log("Visina:" + visina);

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    is_mobile = "Yes";
    console.log("Mobitel je");
  }


  // Dimming ikona kod scrolanja i malo nakon

  
 

  // $(window).on('scroll', function() {
  //   $('.facebook-link').css('opacity','0.5');
  //   $('.wa__btn_popup').css('opacity','0.5');
  //   $(this).off('scroll')[0].setTimeout(function(){
  //     $('.facebook-link').css('opacity','1');
  //     $('.wa__btn_popup').css('opacity','1');
  //   }, 2000)
  // });

  $(window).scroll(function() {
    clearTimeout($.data(this, 'scrollTimer'));
    $('.facebook-link').addClass("polu-vidljiv");
    $('.facebook-link').removeClass("vidljiv");
    $('.wa__btn_popup').addClass("polu-vidljiv");
    $('.wa__btn_popup').removeClass("vidljiv");
    $('.scroll-top').addClass("polu-vidljiv");
    $('.scroll-top').removeClass("vidljiv");
    $.data(this, 'scrollTimer', setTimeout(function() {
        // do something
        // console.log("Haven't scrolled in 250ms!");
      $('.facebook-link').addClass("vidljiv");
      $('.facebook-link').removeClass("polu-vidljiv");
      $('.wa__btn_popup').addClass("vidljiv");
      $('.wa__btn_popup').removeClass("polu-vidljiv");
      $('.scroll-top').addClass("vidljiv");
      $('.scroll-top').removeClass("polu-vidljiv");
    }, 2000));
});


  // Pozicija kursora kad se dogovdi klik

  document.addEventListener("click", function (event) {
    pozicijaX = event.clientX;
    pozicijaY = event.clientY;
    // console.log("X: " + pozicijaX + " Y: " + pozicijaY);
  });

  $(window).resize(function() {
    console.log('Promjena');
    $('.menu-wrapper').css('height','100vh');
  });

  // Menu

  function menu_scroll() {
    var $window = $(window);
    var previousScrollPosition = $window.scrollTop();
    var scrollTicking = false;

    function updatePrimaryMenu() {
      var currentScrollPosition = $window.scrollTop();
      var $primaryMenu = $("#primary-menu");

      if (!$primaryMenu.length) {
        scrollTicking = false;
        return;
      }

      if (currentScrollPosition <= 50) {
        $primaryMenu.removeClass("bof-nav-hidden bof-nav-scrolled fixed unfixed");
        $(".logo-menu").css("display", "none");
      } else if (currentScrollPosition > previousScrollPosition + 2) {
        $primaryMenu.addClass("bof-nav-hidden bof-nav-scrolled").removeClass("fixed unfixed");
      } else if (currentScrollPosition < previousScrollPosition - 2) {
        $primaryMenu.removeClass("bof-nav-hidden fixed unfixed").addClass("bof-nav-scrolled");
        $(".logo-menu").css("display", currentScrollPosition > 250 ? "inline" : "none");
      }

      previousScrollPosition = currentScrollPosition;
      scrollTicking = false;
    }

    $window.off("scroll.bofPrimaryMenu").on("scroll.bofPrimaryMenu", function () {
      if (!scrollTicking) {
        window.requestAnimationFrame(updatePrimaryMenu);
        scrollTicking = true;
      }
    });

    updatePrimaryMenu();
  }

  // menu_scroll();

  // End menu

  // Logo rotacija
  var textPath = gsap.timeline({
    repeat: -1,
  });
  textPath.from("#mainText", {
    duration: 5,
    rotation: 360,
    transformOrigin: "50% 50%",
  });

  // var text = document.querySelectorAll(".mainTextButton");
  // gsap.from(text, { duration: 10, repeat: -1, ease: "linear", rotation: 360, transformOrigin: "50% 50%" });

  // gsap.from("#mainTextButton", { duration: 10, repeat: -1, ease: "linear", rotation: 360, transformOrigin: "50% 50%" });

  //Kursor

  function kursor() {
    if (window.matchMedia("(min-width: 768px)").matches) {
      let mouseCursorInner = document.querySelector(".cursor--inner");
      let mouseCursorOuter = document.querySelector(".cursor--outer");
      let linkovi = document.querySelectorAll("a, .button, button, .wa__btn_popup");

      window.addEventListener("mousemove", cursor);

      function cursor(e) {
        mouseCursorOuter.style.top = e.pageY + "px";
        mouseCursorOuter.style.left = e.pageX + "px";
        mouseCursorInner.style.top = e.pageY + "px";
        mouseCursorInner.style.left = e.pageX + "px";
      }

      linkovi.forEach((link) => {
        link.addEventListener("mouseleave", () => {
          mouseCursorOuter.classList.remove("link-grow");
        });
        link.addEventListener("mouseover", () => {
          mouseCursorOuter.classList.add("link-grow");
        });
      });
    }
  }

  // function slikaTranzicija() {
  // 	var slikaClick;
  // 	$(document).on("click", ".mediji-post", function () {
  // 		return slikaClick = $('img', this);
  // 	});
  // }
  // slikaTranzicija();

  // }

  // $(window).load(function() {
  // 	kursor();
  // })

  //Kursor kraj

  // Menu - otvaranje i animacije

  // $('.nav-button').off('click').on('click', function() {
  // 	$('.menu').toggleClass('openclose');
  //   });

  function shouldPreventBarbaNavigation() {
    // Barba remains initialized for compatibility with the existing theme,
    // but every link uses a normal full-page navigation.
    return true;
  }

  function open_menu() {
    var $document = $(document);
    var $body = $("body");
    var $primaryNav = $("#primary-menu");
    var $menuButton = $(".nav-button");
    var $mobileNav = $("#full-nav");
    var $mobileMenu = $mobileNav.find(".menu");
    var lastFocusedElement = null;
    var submenuLabels = {
      hr: { open: "Otvori podizbornik", close: "Zatvori podizbornik" },
      en: { open: "Open submenu", close: "Close submenu" },
      de: { open: "Untermenü öffnen", close: "Untermenü schließen" }
    };
    var languageCode = (document.documentElement.lang || "hr").slice(0, 2).toLowerCase();
    var submenuCopy = submenuLabels[languageCode] || submenuLabels.hr;

    function getParentLabel($toggle) {
      return $toggle.siblings(".bof-parent-link").first().text().trim();
    }

    function setSubmenuToggleState($toggle, isOpen) {
      var actionLabel = isOpen ? submenuCopy.close : submenuCopy.open;
      var parentLabel = getParentLabel($toggle);

      $toggle
        .attr("aria-expanded", isOpen ? "true" : "false")
        .attr("aria-label", parentLabel ? actionLabel + ": " + parentLabel : actionLabel);
    }

    function closeDesktopSubmenus($exceptItem) {
      var $openItems = $primaryNav.find("#main-menu-top-front > .menu-item-has-children.show, #main-menu > .menu-item-has-children.show");

      if ($exceptItem && $exceptItem.length) {
        $openItems = $openItems.not($exceptItem);
      }

      $openItems.removeClass("show").each(function () {
        setSubmenuToggleState($(this).children(".bof-desktop-submenu-toggle"), false);
      });
    }

    function resetMobileSubmenus() {
      $mobileNav.find("#full-menu-dodatak-top > .menu-item-has-children")
        .removeClass("is-open")
        .each(function () {
          setSubmenuToggleState($(this).children(".bof-mobile-submenu-toggle"), false);
        });
    }

    function setMobileMenuState(isOpen, returnFocus) {
      var openLabel = $menuButton.attr("data-open-label") || "Otvori izbornik";
      var closeLabel = $menuButton.attr("data-close-label") || "Zatvori izbornik";

      $mobileMenu.toggleClass("is-open", isOpen);
      $menuButton
        .toggleClass("is-open", isOpen)
        .attr("aria-expanded", isOpen ? "true" : "false")
        .attr("aria-label", isOpen ? closeLabel : openLabel)
        .find(".sr-only")
        .text(isOpen ? closeLabel : openLabel);
      $mobileNav.attr("aria-hidden", isOpen ? "false" : "true");
      $body.toggleClass("bof-menu-open", isOpen);

      if (isOpen) {
        lastFocusedElement = document.activeElement;
        window.setTimeout(function () {
          $mobileMenu.find("a:visible, button:visible").first().trigger("focus");
        }, 80);
      } else {
        resetMobileSubmenus();
        if (returnFocus && lastFocusedElement) {
          $(lastFocusedElement).trigger("focus");
        }
      }
    }

    function bindBarbaMenuNavigation($nav) {
      var nav = $nav.get(0);

      if (!nav || nav.__bofBarbaNavigationBound) {
        return;
      }

      nav.__bofBarbaNavigationBound = true;
      nav.addEventListener("click", function (event) {
        var link = event.target.closest("a");

        if (
          !link ||
          !nav.contains(link) ||
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          link.hasAttribute("download") ||
          (link.target && link.target !== "_self") ||
          link.getAttribute("data-barba-prevent") ||
          link.getAttribute("href") === "#"
        ) {
          return;
        }

        var destination = new URL(link.href, window.location.href);
        var isSamePageHash =
          destination.origin === window.location.origin &&
          destination.pathname === window.location.pathname &&
          destination.search === window.location.search &&
          destination.hash;

        if (destination.origin !== window.location.origin || isSamePageHash) {
          return;
        }

        if (shouldPreventBarbaNavigation({ el: link, href: destination.href })) {
          return;
        }

        // GTM-ov "Wait for Tags" link listener naknadno postavlja
        // window.location.href. Zaustavi klik prije document razine i isti
        // prijelaz pokreni izravno kroz Barbu kako ne bi uslijedio puni reload.
        event.preventDefault();
        event.stopPropagation();

        if (nav.id === "full-nav") {
          setMobileMenuState(false, false);
        }

        bofBarba.go(destination.href, link, event);
      });
    }

    $primaryNav.find("#main-menu-top-front > .menu-item-has-children, #main-menu > .menu-item-has-children").each(function (index) {
      var $item = $(this);
      var $link = $item.children("a").first();
      var $submenu = $item.children(".dropdown-menu").first();
      var itemId = $item.attr("id") || "item-" + index;
      var submenuId = $submenu.attr("id") || "bof-desktop-submenu-" + itemId;
      var $toggle = $item.children(".bof-desktop-submenu-toggle");

      $submenu.attr("id", submenuId);
      $link
        .addClass("bof-parent-link")
        .removeClass("dropdown-toggle")
        .removeAttr("role data-toggle data-bs-toggle aria-haspopup aria-controls aria-expanded");

      if (!$toggle.length) {
        $toggle = $('<button type="button" class="bof-desktop-submenu-toggle"><span aria-hidden="true"></span></button>');
        $toggle.insertAfter($link);
      }

      $toggle.attr({
        "aria-controls": submenuId,
        "aria-haspopup": "true"
      });
      setSubmenuToggleState($toggle, $item.hasClass("show"));
    });

    $mobileNav.find("#full-menu-dodatak-top > .menu-item-has-children").each(function (index) {
      var $item = $(this);
      var $link = $item.children("a").first();
      var $submenu = $item.children(".dropdown-menu").first();
      var itemId = $item.attr("id") || "item-" + index;
      var submenuId = $submenu.attr("id") || "bof-mobile-submenu-" + itemId;
      var $toggle = $item.children(".bof-mobile-submenu-toggle");

      $submenu.attr("id", submenuId);
      $link
        .addClass("bof-parent-link")
        .removeClass("dropdown-toggle")
        .removeAttr("role data-toggle data-bs-toggle aria-haspopup aria-controls aria-expanded");

      if (!$toggle.length) {
        $toggle = $('<button type="button" class="bof-mobile-submenu-toggle"><span aria-hidden="true"></span></button>');
        $toggle.insertAfter($link);
      }

      $toggle.attr({
        "aria-controls": submenuId,
        "aria-haspopup": "true"
      });
      setSubmenuToggleState($toggle, $item.hasClass("is-open"));
    });

    setMobileMenuState(false, false);
    bindBarbaMenuNavigation($primaryNav);
    bindBarbaMenuNavigation($mobileNav);

    $document.off(".bofDesktopSubmenu");
    $document.off(".bofMobileMenu");

    $document.on("click.bofDesktopSubmenu", "#primary-menu .bof-desktop-submenu-toggle", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var $toggle = $(this);
      var $item = $toggle.parent(".menu-item-has-children");
      var shouldOpen = !$item.hasClass("show");

      $item.removeClass("bof-suppress-hover");
      closeDesktopSubmenus($item);
      $item.toggleClass("show", shouldOpen);
      setSubmenuToggleState($toggle, shouldOpen);
    });

    $document.on("click.bofDesktopSubmenu", "#primary-menu .menu-item-has-children > .bof-parent-link[href='#']", function (event) {
      event.preventDefault();
      $(this).siblings(".bof-desktop-submenu-toggle").trigger("click");
    });

    $document.on("click.bofDesktopSubmenu", function () {
      closeDesktopSubmenus();
    });

    $document.on("mouseenter.bofDesktopSubmenu", "#primary-menu #main-menu-top-front > .menu-item-has-children, #primary-menu #main-menu > .menu-item-has-children", function () {
      if ($(this).hasClass("bof-suppress-hover")) {
        return;
      }

      setSubmenuToggleState($(this).children(".bof-desktop-submenu-toggle"), true);
    });

    $document.on("mouseleave.bofDesktopSubmenu", "#primary-menu #main-menu-top-front > .menu-item-has-children, #primary-menu #main-menu > .menu-item-has-children", function () {
      var item = this;

      window.setTimeout(function () {
        var $item = $(item);
        var stillFocused = $.contains(item, document.activeElement);

        $item.removeClass("bof-suppress-hover");

        if (!$item.hasClass("show") && !stillFocused && !$item.is(":hover")) {
          setSubmenuToggleState($item.children(".bof-desktop-submenu-toggle"), false);
        }
      }, 0);
    });

    $document.on("keydown.bofDesktopSubmenu", function (event) {
      var $openItem = $primaryNav
        .find("#main-menu-top-front > .menu-item-has-children, #main-menu > .menu-item-has-children")
        .filter(function () {
          return $(this).hasClass("show") || $(this).children(".bof-desktop-submenu-toggle").attr("aria-expanded") === "true";
        })
        .first();

      if (event.key !== "Escape" || !$openItem.length) {
        return;
      }

      event.preventDefault();
      var $toggle = $openItem.children(".bof-desktop-submenu-toggle");
      $openItem.addClass("bof-suppress-hover");
      closeDesktopSubmenus();
      setSubmenuToggleState($toggle, false);
      $toggle.trigger("focus");
    });

    $document.on("click.bofMobileMenu", ".nav-button", function () {
      setMobileMenuState(!$mobileMenu.hasClass("is-open"), true);
    });

    $document.on("click.bofMobileMenu", "#full-nav .bof-mobile-submenu-toggle", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var $toggle = $(this);
      var $item = $toggle.parent(".menu-item-has-children");
      var shouldOpen = !$item.hasClass("is-open");

      $item.siblings(".menu-item-has-children.is-open")
        .removeClass("is-open")
        .each(function () {
          setSubmenuToggleState($(this).children(".bof-mobile-submenu-toggle"), false);
        });

      $item.toggleClass("is-open", shouldOpen);
      setSubmenuToggleState($toggle, shouldOpen);

      // Other delegated menu handlers can run later in the same click cycle.
      // Synchronize the accessibility state once more with the final UI state.
      window.setTimeout(function () {
        setSubmenuToggleState($toggle, $item.hasClass("is-open"));
      }, 0);
    });

    $document.on("click.bofMobileMenu", "#full-nav .menu-item-has-children > .bof-parent-link[href='#']", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).siblings(".bof-mobile-submenu-toggle").trigger("click");
    });

    $document.on("click.bofMobileMenu", "#full-nav a", function () {
      if ($(this).attr("href") === "#") {
        return;
      }

      setMobileMenuState(false, false);
    });

    $document.on("keydown.bofMobileMenu", function (event) {
      if (!$mobileMenu.hasClass("is-open")) {
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        setMobileMenuState(false, true);
        return;
      }

      if (event.key === "Tab") {
        var $focusable = $mobileMenu.find("a:visible, button:visible");
        var firstElement = $focusable.get(0);
        var lastElement = $focusable.get($focusable.length - 1);

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          $(lastElement).trigger("focus");
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          $(firstElement).trigger("focus");
        }
      }
    });
  }

  // Menu kraj

  // Scroll top

  $(document).ready(function () {
    var prevpos = 0;

    $(window).scroll(function () {
      var currPos = $(window).scrollTop();

      if ($(document).scrollTop() > 1000) {
        if (currPos > prevpos) {
          // Idem dolje
          $(".scroll-top").removeClass("nevidljiv");
          $(".scroll-top").addClass("vidljiv");
          // console.log('1');
        } else {
          // Idem gore
          $(".scroll-top").removeClass("nevidljiv");
          // console.log('2');
        }
      } else {
        // Na vrhu sam
        $(".scroll-top").addClass("nevidljiv");
        // console.log('3');
      }
      prevpos = currPos;
    });
  });

  function play_video() {
    let link1 = $(".videoWrapper-youtube-1 iframe")[0].src;
    let link2 = $(".videoWrapper-youtube-2 iframe")[0].src;
    // var visina = ($(window).height());
    // var sirina = ($(window).width());
    // console.log("Širina:" + sirina);
    // console.log("Visina:" + visina);

    // console.log("Top:" + top);

    $(".videolink-1").on("click", function () {
      var top = $(window).scrollTop();
      var bottom = $(window).scrollTop() + $(window).height();
      // console.log("Top:" + top);
      // console.log("Bottom:" + bottom);
      var visina = bottom - top;
      $(".videoWrapper-youtube-1").css("display", "block");
      $(".videoWrapper-youtube-1").css("top", top);
      $(".videoWrapper-youtube-1").css("height", visina);
      $("body").css("overflow-y", "hidden");
      $("iframe")[0].src += "&autoplay=1";
      $(".videoWrapper-youtube-1").css("z-index", "100001");
      $(".krugovi").css("opacity", "0");
      var tl = gsap.timeline();
      tl.from(this, {
        scale: 2,
        ease: "power3",
        duration: 1,
      });
      tl.to(
        ".videoWrapper-youtube-1",
        {
          scale: 1,
          opacity: 1,
          ease: "power3",
          duration: 1,
        },
        "-=1"
      );
    });

    let proven = window.matchMedia("(orientation: portrait)");

    // proven.addEventListener("change", function (e) {
    //   if (e.matches) {
    //     var top = $(window).scrollTop();
    //     var bottom = $(window).scrollTop() + $(window).height();
    //     var visina = bottom - top;
    //     $(".videoWrapper-youtube-1").css("display", "block");
    //   $(".videoWrapper-youtube-1").css("top", top);
    //   $(".videoWrapper-youtube-1").css("height", visina);
    //   $(".videoWrapper-youtube-2").css("display", "block");
    //   $(".videoWrapper-youtube-2").css("top", top);
    //   $(".videoWrapper-youtube-2").css("height", visina);
    //   } else {
    //     var top = $(window).scrollTop();
    //     var bottom = $(window).scrollTop() + $(window).height();
    //     var visina = bottom - top;
    //     $(".videoWrapper-youtube-1").css("display", "block");
    //   $(".videoWrapper-youtube-1").css("top", top);
    //   $(".videoWrapper-youtube-1").css("height", visina);
    //   $(".videoWrapper-youtube-2").css("display", "block");
    //   $(".videoWrapper-youtube-2").css("top", top);
    //   $(".videoWrapper-youtube-2").css("height", visina);
    //   }
    // });

    $(".video-close-1").on("click", function () {
      $(".videoWrapper-youtube-1 iframe")[0].src = link1;
      $("body").css("overflow-y", "unset");
      $(".krugovi").css("opacity", "1");
      var tl1 = gsap.timeline();
      tl1.to(".videoWrapper-youtube-1", {
        scale: 0.9,
        opacity: 0,
        display: "none",
        ease: "power3",
        duration: 1,
      });
    });

    $(".videolink-2").on("click", function () {
      var top = $(window).scrollTop();
      var bottom = $(window).scrollTop() + $(window).height();
      // console.log("Top:" + top);
      // console.log("Bottom:" + bottom);
      var visina = bottom - top;
      $(".videoWrapper-youtube-2").css("display", "block");
      $(".videoWrapper-youtube-2").css("top", top);
      $(".videoWrapper-youtube-2").css("height", visina);
      $("body").css("overflow-y", "hidden");
      $("iframe")[1].src += "&autoplay=1";
      $(".videoWrapper-youtube-2").css("z-index", "100001");
      $(".krugovi").css("opacity", "0");
      // $('.videoWrapper-youtube-3').css('opacity','1');
      var tl = gsap.timeline();
      tl.from(this, {
        scale: 2,
        ease: "power3",
        duration: 1,
      });
      tl.to(
        ".videoWrapper-youtube-2",
        {
          scale: 1,
          opacity: 1,
          ease: "power3",
          duration: 1,
        },
        "-=1"
      );
    });

    $(".video-close-2").on("click", function () {
      // console.log("Close3");
      $(".videoWrapper-youtube-2 iframe")[0].src = link2;
      $("body").css("overflow-y", "unset");
      $(".krugovi").css("opacity", "1");
      var tl1 = gsap.timeline();
      tl1.to(".videoWrapper-youtube-2", {
        scale: 0.9,
        opacity: 0,
        display: "none",
        ease: "power3",
        duration: 1,
      });
      // $('.videoWrapper-youtube-3').css('z-index','1');
      // $('.videoWrapper-youtube-3').css('display','none');
    });
  }

  // Activate only if not already activated
  if (window.hideYTActivated) return;
  // Load API
  if (typeof YT === "undefined") {
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  // Activate on all players
  let onYouTubeIframeAPIReadyCallbacks = [];
  for (let playerWrap of document.querySelectorAll(".videoWrapper-youtube")) {
    let playerFrame = playerWrap.querySelector("iframe");

    let onPlayerStateChange = function (event) {
      if (event.data == YT.PlayerState.ENDED) {
        playerWrap.classList.add("ended");
      } else if (event.data == YT.PlayerState.PAUSED) {
        playerWrap.classList.add("paused");
        // console.log('Pauza');
      } else if (event.data == YT.PlayerState.PLAYING) {
        playerWrap.classList.remove("ended");
        playerWrap.classList.remove("paused");
      }
    };

    let player;
    onYouTubeIframeAPIReadyCallbacks.push(function () {
      player = new YT.Player(playerFrame, {
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    });

    playerWrap.addEventListener("click", function () {
      let playerState = player.getPlayerState();
      if (playerState == YT.PlayerState.ENDED) {
        player.seekTo(0);
      } else if (playerState == YT.PlayerState.PAUSED) {
        player.playVideo();
      }
    });
  }

  window.onYouTubeIframeAPIReady = function () {
    for (let callback of onYouTubeIframeAPIReadyCallbacks) {
      callback();
    }
  };

  window.hideYTActivated = true;

  // Naziv slike

  function NazivSlike() {
    $(".naziv-slike a")
      .on("mouseover", function () {
        $(".slika-heroslider").css("background-color", "transparent");
      })
      .on("mouseout", function () {
        $(".slika-heroslider").css("background-color", "#59040d");
      });
  }

  // $(window).load(function() {
  // 	NazivSlike();
  // });

  //Lazyload images

  // blurryImageLoad.load();

  // Scroll to top

  function ScrollTop() {
    $(window).scrollTop(0);
    // $("html, body").animate({ scrollTop: 0 }, "fast");
  }

  $(".hero-slide-pozadina").css("opacity", 0);

  $(".site")
    .imagesLoaded()
    .always(function (instance) {
      //   console.log('all images loaded');
    })
    .done(function (instance) {
      //   console.log('all images successfully loaded');

      $(".hero-slide-pozadina").css("opacity", 1);
      $(".hero-overlay").css("height", $(".grid").height());
      // $('.grid').isotope({
      // 	itemSelector: '.slika-heroslider',
      // });
    })
    .fail(function () {
      //   console.log('all images loaded, at least one is broken');
    })
    .progress(function (instance, image) {
      // var result = image.isLoaded ? 'loaded' : 'broken';
      //   console.log( 'image is ' + result + ' for ' + image.img.src );
    });

  // Laziload images kraj

  // Slideri

  function hero_slider() {
    var slider_hero = tns({
      container: ".hero_slide",
      mode: "gallery",
      // animateIn:'in',
      // animateOut: 'out',
      items: 1,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: "10000",
      controls: false,
      controlsPosition: "bottom",
      autoplayHoverPause: true,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      nav: false,
      touch: false,
      responsive: {
        1180: {
          items: 1,
        },
        1440: {
          items: 1,
        },
        1920: {
          items: 1,
        },
      },
    });

    $(".next-hero").on("click", function () {
      slider_hero.goTo("next");
    });
    $(".prev-hero").on("click", function () {
      slider_hero.goTo("prev");
    });
  }

  // if ($(".hero_slide").length) {
  //   hero_slider();
  // }

  // var animacija_naslovnica = function() {
  // 	var tl = gsap.timeline();
  // 	tl.fromTo('.hero-text h1', {left: -1000, opacity: 0}, {left: '0%', duration: 2, opacity: 1, ease: "power3"})
  // 	tl.fromTo('.hero-text h2', {left: -1000, opacity: 0}, {left: '0%', duration: 2, opacity: 1, ease: "power3"}, "-=1")
  // 	tl.fromTo('.naziv-slike', {right: -1000, opacity: 0}, {right: 100, duration: 2, opacity: 1, ease: "power3"}, "-=2")
  // }

  // slider_hero.events.on('transitionStart', animacija_naslovnica);

  function slider_novosti() {
    var slider = tns({
      container: ".slider",
      items: 1,
      slideBy: 1,
      autoplay: true,
      controls: false,
      controlsPosition: "bottom",
      autoplayHoverPause: true,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      gutter: 20,
      nav: false,
      responsive: {
        674: {
          items: 2,
        },
        1180: {
          items: 3,
        },
        1440: {
          items: 4,
        },
        1920: {
          items: 5,
        },
      },
    });

    $(".next-novosti").on("click", function () {
      slider.goTo("next");
    });
    $(".prev-novosti").on("click", function () {
      slider.goTo("prev");
    });
  }

  // $(window).load(function() {
  // 	slider_novosti();
  // })

  function slider_kittens() {
    var slider_kittens = tns({
      container: ".slider-kittens",
      items: 1,
      slideBy: 1,
      autoplay: true,
      controls: false,
      controlsPosition: "bottom",
      autoplayHoverPause: true,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      gutter: 40,
      nav: false,
      // autoWidth: true,
      responsive: {
        674: {
          items: 2,
        },
        1180: {
          items: 3,
        },
        1600: {
          items: 4,
        },
        1920: {
          items: 5,
        },
      },
    });

    $(".next-kittens").on("click", function () {
      slider_kittens.goTo("next");
    });
    $(".prev-kittens").on("click", function () {
      slider_kittens.goTo("prev");
    });
  }

  // $(window).load(function() {
  // 	slider_kittens();
  // })

  function slider_rezultati() {
    var slider_rezultati = tns({
      container: ".slider-rezultati",
      items: 1,
      slideBy: 1,
      autoplay: true,
      controls: false,
      controlsPosition: "bottom",
      autoplayHoverPause: false,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      gutter: 25,
      nav: false,
      // autoWidth: true,
      responsive: {
        674: {
          items: 2,
        },
        1180: {
          items: 3,
        },
        1440: {
          items: 4,
        },
        1920: {
          items: 5,
        },
      },
    });

    $(".next-rezultati").on("click", function () {
      slider_rezultati.goTo("next");
    });
    $(".prev-rezultati").on("click", function () {
      slider_rezultati.goTo("prev");
    });
  }

  // $(window).load(function() {
  // 	slider_rezultati();
  // })

  function slider_footer() {
    var slider_footer = tns({
      container: ".slider-footer",
      mode: "gallery",
      items: 1,
      slideBy: 1,
      autoplay: true,
      controls: false,
      controlsPosition: "bottom",
      autoplayHoverPause: true,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      gutter: 10,
      nav: false,
      // autoWidth: true,
      responsive: {
        674: {
          items: 1,
        },
        1180: {
          items: 1,
        },
        1440: {
          items: 1,
        },
        1920: {
          items: 1,
        },
      },
    });

    $(".next-footer").on("click", function () {
      slider_footer.goTo("next");
    });
    $(".prev-footer").on("click", function () {
      slider_footer.goTo("prev");
    });
  }

  // $(window).load(function() {
  // 	slider_footer();
  // })

  // Slideri kraj

  function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
      setTimeout(() => {
        done();
      }, n);
    });
  }

  // On narrow screens, comparison tables become readable product cards.
  // Labels are copied from the current table header, so translated articles
  // do not need separate markup or hard-coded Croatian/English/German labels.
  function initResponsiveComparisonTables(scope) {
    var $scope = scope ? $(scope) : $(document);

    $scope.find(".bof-comparison-table table").each(function () {
      var $table = $(this);
      var labels = $table
        .find("thead th")
        .map(function () {
          return $.trim($(this).text());
        })
        .get();

      if (!labels.length) {
        return;
      }

      $table.find("tbody tr").each(function () {
        $(this)
          .children("th, td")
          .each(function (index) {
            if (labels[index]) {
              $(this).attr("data-label", labels[index]);
            }
          });
      });

      $table
        .closest(".bof-comparison-table")
        .addClass("bof-comparison-table--responsive");
    });
  }

  var post = $(this).find("");

  // Barba bez View

  // barba.use(barbaCss);

  var bofBarba = barba;

  initResponsiveComparisonTables(document);

  bofBarba.init({
    debug: false,
    timeout: 15000,
    prevent: shouldPreventBarbaNavigation,
    transitions: [
      {
        name: "home",
        from: {
          namespace: ["britanske-kratkodlake-macke-3"],
        },
        sync: false,
        preventRunning: true,
        prefetchIgnore: false,
        leave(data) {
          console.log("Leave From Naslovna");
          // var tl = gsap.timeline();
          // tl.to(data.current.container, {opacity: 0, duration: .5, x: 100, stagger: 0.3, onComplete: this.async()});
          var tl = gsap.timeline();
          tl.to("main", {
            opacity: 0,
            duration: 0.5,
            y: 100,
            stagger: 0.3,
            onComplete: this.async(),
          });
          ScrollTop();
          $(".krugovi").css("height", "0");
          $(".krugovi").html("");
          console.log("X: " + pozicijaX + " Y: " + pozicijaY);

          $("primary-menu").css("transform", "");

        },
        enter(data) {
          console.log("Enter From Naslovna");
          var tl1 = gsap.timeline();
          tl1.from("main", {
            opacity: 0,
            duration: 0.5,
            y: -100,
            stagger: 0.2,
          });
          krugovi();

          $("primary-menu").css("transform", "");
          $(".stranica")
            .imagesLoaded()
            .done(function (instance) {
              $(".hero-slide-pozadina").css("opacity", 1);
              $(".hero-overlay").css("height", $(".grid").height());
              if ($(".hero_slide").length) {
                if (typeof variable === "undefined") {
                  hero_slider();
                } else {
                  slider_hero = slider_hero.rebuild();
                }
                // slider_footer();
              }
              if ($(".slider-novosti").length) {
                slider_novosti();
              }
              if ($(".slider-kittens").length) {
                slider_kittens();
              }
              if ($(".slider-rezultati").length) {
                slider_rezultati();
              }
              if ($(".slider-footer").length) {
                slider_footer();
              }
              if ($(".cover-image").length) {
                gsap.fromTo(
                  ".cover-image img, .title_wrapper",
                  {
                    opacity: 0,
                    y: -100,
                  },
                  {
                    opacity: 1,
                    y: 0,
                  }
                );
              }
              // console.log('all images successfully loaded');
              NazivSlike();
              kursor();
              krugovi();
              ajax_poziv();
              open_menu();
              menu_scroll();
              dodaj_fancybox();
              if ($("video").length) {
                play_video();
              }
              $("html, body").animate(
                {
                  scrollTop: 0,
                },
                "slow"
              );
              var visinaB = $("body").height();
              var sirinaB = $("body").width();
              var visinaW = $(window).height();
              var sirinaW = $(window).width();
              console.log("ŠirinaW: " + sirinaW + " VisinaW: " + visinaW);
              console.log("ŠirinaB: " + sirinaB + " VisinaB: " + visinaB);
            });
        },
        once(data) {
          console.log("Once from Naslovna");
          $(".hero-slide-pozadina").css("opacity", 1);
          var tl = gsap.timeline();
          tl.to(".loader", {
            width: 0,
            duration: 1,
          });
          tl.to(".loader", {
            display: "none",
          }); // set se koristi kad
          if ($(".hero_slide").length) {
            if (typeof variable === "undefined") {
              hero_slider();
            } else {
              slider_hero = slider_hero.rebuild();
            }
            // slider_footer();
          }
          if ($(".slider-novosti").length) {
            slider_novosti();
          }
          if ($(".slider-kittens").length) {
            slider_kittens();
          }
          if ($(".slider-rezultati").length) {
            slider_rezultati();
          }
          if ($(".slider-footer").length) {
            slider_footer();
          }
          NazivSlike();
          kursor();
          krugovi();
          ajax_poziv();
          open_menu();
          menu_scroll();
          dodaj_fancybox();
          if ($("video").length) {
            play_video();
          }
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            "slow"
          );
        },
      },
      {
        name: "other",
        to: {
          namespace: ["britanske-kratkodlake-macke-3"],
        },
        leave(data) {
          console.log("Leave to Naslovna");
          var tl = gsap.timeline();
          tl.to("main", {
            opacity: 0,
            duration: 0.5,
            y: 100,
            stagger: 0.3,
            onComplete: this.async(),
          });

          ScrollTop();
          $(".krugovi").css("height", "0");
          $(".krugovi").html("");
          console.log("X: " + pozicijaX + " Y: " + pozicijaY);
          if ($(".cover-image").length) {
            gsap.fromTo(
              ".cover-image img, .title_wrapper",
              {
                opacity: 1,
                y: 0,
              },
              {
                opacity: 0,
                y: -100,
              }
            );
          }
        },
        enter(data) {
          console.log("Enter to Naslovna");
          var tl1 = gsap.timeline();
          tl1.from("main", {
            opacity: 0,
            duration: 0.5,
            y: -100,
            stagger: 0.2,
          });
          $(".stranica")
            .imagesLoaded()
            .done(function (instance) {
              $(".hero-slide-pozadina").css("opacity", 1);
              $(".hero-overlay").css("height", $(".grid").height());
              if ($(".hero_slide").length) {
                if (typeof variable === "undefined") {
                  hero_slider();
                } else {
                  slider_hero = slider_hero.rebuild();
                }
                // slider_footer();
              }
              if ($(".slider-novosti").length) {
                slider_novosti();
              }
              if ($(".slider-kittens").length) {
                slider_kittens();
              }
              if ($(".slider-rezultati").length) {
                slider_rezultati();
              }
              if ($(".slider-footer").length) {
                slider_footer();
              }
              // console.log('all images successfully loaded');
              NazivSlike();
              kursor();
              krugovi();
              ajax_poziv();
              open_menu();
              menu_scroll();
              dodaj_fancybox();
              $("html, body").animate(
                {
                  scrollTop: 0,
                },
                "slow"
              );

              if ($("video").length) {
                play_video();
                let videos = document.querySelectorAll("video");
                var d;
                for (d = 0; d < videos.length; d++) {
                  videos[d].play();
                }
              }
            });
        },
        once(data) {
          console.log("Once to Naslovna");
          $(".hero-slide-pozadina").css("opacity", 1);
          var tl = gsap.timeline();
          tl.to(".loader", {
            width: 0,
            duration: 1,
          });
          tl.to(".loader", {
            display: "none",
          }); // set se koristi kad
          if ($(".hero_slide").length) {
            if (typeof variable === "undefined") {
              hero_slider();
            } else {
              slider_hero = slider_hero.rebuild();
            }
            // slider_footer();
          }
          if ($(".slider-novosti").length) {
            slider_novosti();
          }
          if ($(".slider-kittens").length) {
            slider_kittens();
          }
          if ($(".slider-rezultati").length) {
            slider_rezultati();
          }
          if ($(".slider-footer").length) {
            slider_footer();
          }
          open_menu();
          menu_scroll();
          NazivSlike();
          kursor();
          krugovi();
          ajax_poziv();
          dodaj_fancybox();
          if ($("video").length) {
            play_video();
          }
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            "slow"
          );
        },
      },
      {
        name: "all",
        leave(data) {
          console.log("Leave ALL");
          // Animacija kliknute slike
          var tl = gsap.timeline();
          // if ($('.mediji-post').length) {

          // 	$(document).on("click", ".spol", function () {
          // 		var slikaClick = $(this).find('.novosti-slika img');
          // 		var pozicija = slikaClick.position();
          // 		console.log("Left:" + pozicija.left + "  Top:" + pozicija.top)
          // 		tl.to(slikaClick, {
          // 			border: 'none',
          // 			borderRadius: 0,
          // 			opacity: 0,
          // 			width: '100vw',
          // 			duration: 0.5,
          // 			transformOrigin: 'left top',
          // 			y: pozicija.top - visinaW,
          // 			x: -pozicija.left - 100,
          // 			maxWidth: 'unset',
          // 			aspectRatio: "16/11",
          // 		});
          // 		// console.log('Animacije je napravljena')
          // 	});
          // }
          // tl.to('.loader', {
          // 	display: "inline"
          // })
          // tl.to('.loader', {
          // 	width: "100%",
          // 	duration: .3
          // })

          tl.to("main", {
            opacity: 0,
            duration: 1,
            y: 100,
            stagger: 0.3,
            onComplete: this.async(),
          });

          if ($(".cover-image").length) {
            gsap.fromTo(
              ".cover-image img, .title_wrapper",
              {
                opacity: 1,
                y: 0,
              },
              {
                opacity: 0,
                y: -100,
              }
            );
          }

          if ($(".mediji-tekst").length) {
            gsap.to(".mediji-tekst", {
              opacity: 0,
              y: -100,
            });
          }

          console.log("X: " + pozicijaX + " Y: " + pozicijaY);

          $(".krugovi").css("height", "0");
          $(".krugovi").html("");
        },
        enter(data) {
          console.log("Enter ALL");
          var tl1 = gsap.timeline();
          tl1.from("main", {
            opacity: 0,
            duration: 0.5,
            y: -100,
            stagger: 0.2,
          });
          // tl1.to('.loader', {
          // 	width: 0,
          // 	duration: .3
          // })
          // tl1.to('.loader', {
          // 	display: "none"
          // })

          // set se koristi kad
          $(".stranica")
            .imagesLoaded()
            .done(function (instance) {
              if ($(".hero_slide").length) {
                if (typeof variable === "undefined") {
                  hero_slider();
                } else {
                  slider_hero = slider_hero.rebuild();
                }
                // slider_footer();
              }
              if ($(".slider-novosti").length) {
                slider_novosti();
              }
              if ($(".slider-kittens").length) {
                slider_kittens();
              }
              if ($(".slider-rezultati").length) {
                slider_rezultati();
              }
              if ($(".slider-footer").length) {
                slider_footer();
              }
              if ($(".cover-image").length) {
                gsap.fromTo(
                  ".cover-image img, .title_wrapper",
                  {
                    opacity: 0,
                    y: -100,
                  },
                  {
                    opacity: 1,
                    y: 0,
                  }
                );
              }
              if ($(".mediji-tekst").length) {
                gsap.fromTo(
                  ".mediji-tekst",
                  {
                    opacity: 0,
                    y: -100,
                    duration: 1,
                  },
                  {
                    opacity: 1,
                    y: 0,
                  }
                );
              }
              open_menu();
              NazivSlike();
              kursor();
              ajax_poziv();
              krugovi();
              menu_scroll();
              dodaj_fancybox();
              if ($("video").length) {
                play_video();
              }
              $("html, body").animate(
                {
                  scrollTop: 0,
                },
                "slow"
              );
            });
        },
        once(data) {
          console.log("Once ALL");
          var tl = gsap.timeline();
          // if ($('.mediji-post').length) {

          // 	$(document).on("click", ".spol", function () {
          // 		var slikaClick = $(this).find('.novosti-slika a img');
          // 		tl.to(slikaClick, {
          // 			opacity: 0,
          // 			scale: 3,
          // 			duration: .5,
          // 			y: -innerHeight,
          // 			borderRadius: '0px',
          // 		});
          // 		console.log('Animacije je napravljena')

          // 	});
          // }
          tl.to(".loader", {
            width: 0,
            duration: 1,
          });
          tl.to(".loader", {
            display: "none",
          }); // set se koristi kad
          if ($(".hero_slide").length) {
            hero_slider();
          }
          if ($(".slider-novosti").length) {
            slider_novosti();
          }
          if ($(".slider-kittens").length) {
            slider_kittens();
          }
          if ($(".slider-rezultati").length) {
            slider_rezultati();
          }
          if ($(".slider-footer").length) {
            slider_footer();
          }
          if ($(".cover-image").length) {
            gsap.fromTo(
              ".cover-image img, .title_wrapper",
              {
                opacity: 0,
                y: -100,
              },
              {
                opacity: 1,
                y: 0,
              }
            );
          }

          if ($(".mediji-tekst").length) {
            gsap.fromTo(
              ".mediji-tekst",
              {
                opacity: 0,
                y: -100,
                duration: 1,
              },
              {
                opacity: 1,
                y: 0,
              }
            );
          }
          open_menu();
          menu_scroll();
          NazivSlike();
          kursor();
          krugovi();
          ajax_poziv();
          dodaj_fancybox();
          if ($("video").length) {
            play_video();
          }
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            "slow"
          );
        },
      },
    ],
  });

  // barba.hooks.enter(() => { window.scrollTo(0, 0); });

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // Krugovi
  function krugovi() {
    var n = 0;
    var xP = 0;
    var yP = 0;
    var rSize = 0;
    var fillColor = "000000";
    var fillColorNew = ["4E040B", "741F18", "EEBD6A"];
    var fillColorNew1 = "";
    var temp = "";
    var svg = "";
    var delay = 0;
    var fillOpacity = 0;
    var text = "";
    var raster = "";
    var visina = 0;
    visina = $("body").height();
    // console.log(visina);
    $(".krugovi").height(visina);
    if (visina < 2500) {
      var numberOfCircles = Math.floor(Math.random() * (100 - 50) + 10);
      // console.log("Manje");
    } else if (visina > 2500 && visina < 4999) {
      var numberOfCircles = Math.floor(Math.random() * (100 - 50) + 50);
      // console.log("Više");
    } else if (visina > 5000) {
      var numberOfCircles = Math.floor(Math.random() * (100 - 50) + 150);
    }
    // console.log(numberOfCircles);
    // console.log(visina);
    for (var i = 0; i < numberOfCircles; i++) {
      delay = Math.floor(Math.random() * (10 - 1 + 1) + 1);
      xP = Math.floor(Math.random() * (1920 - 100 + 1) + 100);
      yP = Math.floor(Math.random() * (visina - 100 + 1) + 100);
      rSize = Math.floor(Math.random() * (50 - 10 + 1) + 10);
      fillColor = Math.floor(Math.random() * 16777215).toString(16);
      fillColorNew1 =
        fillColorNew[Math.floor(Math.random() * fillColorNew.length)];
      fillOpacity = Math.random() * (0.3 - 0.1) + 0.1;
      text =
        '<circle class="krugovi1 animated fadeIn delay' +
        delay +
        " " +
        "krug " +
        "krug" +
        i +
        " " +
        '" cx="' +
        xP +
        '" cy="' +
        yP +
        '" r="' +
        rSize +
        '" fill="#' +
        fillColorNew1 +
        '" fill-opacity="' +
        fillOpacity +
        '"/>';
      raster =
        '<g class="raster" transform="translate(' +
        xP +
        " " +
        yP +
        ')"><g><defs><rect id="SVGID_1_" y="0" width="164.7" height="168.5"/></defs><clipPath id="SVGID_2_"><use xlink:href="#SVGID_1_"  style="overflow:visible;"/></clipPath><g id="Group_75" transform="translate(0 0)" class="st0"><path id="Path_306" class="st1" d="M78.7,95.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,92.1,78.7,93.7,78.7,95.8 M78.7,118.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,115.1,78.7,116.8,78.7,118.8C78.7,118.8,78.7,118.8,78.7,118.8 M78.7,164.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,161.2,78.7,162.8,78.7,164.8 M78.7,141.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,138.2,78.7,139.8,78.7,141.8 M52.4,26.7c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,23,52.4,24.7,52.4,26.7C52.4,26.7,52.4,26.7,52.4,26.7 M78.7,72.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,69.1,78.7,70.7,78.7,72.7 M112.2,118.8c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7C110.6,122.5,112.2,120.8,112.2,118.8 M112.2,141.8c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7C110.6,145.5,112.2,143.8,112.2,141.8 M78.7,3.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,0,78.7,1.6,78.7,3.7C78.7,3.7,78.7,3.7,78.7,3.7 M78.7,26.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,23,78.7,24.7,78.7,26.7C78.7,26.7,78.7,26.7,78.7,26.7 M78.7,49.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C80.3,46.1,78.7,47.7,78.7,49.7C78.7,49.7,78.7,49.7,78.7,49.7 M7.3,95.8c0-2-1.6-3.7-3.6-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7C5.7,99.4,7.3,97.8,7.3,95.8 M7.3,72.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7C5.7,76.4,7.3,74.8,7.3,72.7 M7.3,49.7L7.3,49.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.6-3.7,3.6c0,0.9,0.3,1.8,1,2.5l0,0c0.3,0.4,0.7,0.7,1.2,0.9l0,0c0.5,0.2,1,0.3,1.5,0.3C5.7,53.4,7.3,51.8,7.3,49.7C7.3,49.7,7.3,49.7,7.3,49.7 M105.8,162.4c-0.6,0.7-0.9,1.5-0.9,2.4v0c0,0.5,0.1,0.9,0.3,1.3c0.1,0.3,0.3,0.5,0.4,0.7c0.1,0.1,0.1,0.2,0.2,0.3c0.6,0.6,1.3,1,2.2,1.2h0l0,0c0.2,0.1,0.4,0.1,0.5,0.1c1,0,1.9-0.4,2.6-1.1l0,0c1.4-1.4,1.4-3.8,0-5.2c-0.7-0.7-1.6-1.1-2.6-1.1h0c-0.8,0-1.6,0.3-2.2,0.8c-0.1,0.1-0.3,0.2-0.4,0.3C105.9,162.3,105.9,162.4,105.8,162.4 M112.2,95.8c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7C110.6,99.4,112.2,97.8,112.2,95.8 M52.4,141.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,138.2,52.4,139.8,52.4,141.8 M52.4,72.7c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,69.1,52.4,70.7,52.4,72.7 M52.4,95.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,92.1,52.4,93.7,52.4,95.8 M52.4,118.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,115.1,52.4,116.8,52.4,118.8C52.4,118.8,52.4,118.8,52.4,118.8 M52.4,49.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C54.1,46,52.4,47.7,52.4,49.7C52.4,49.7,52.4,49.7,52.4,49.7 M26.2,26.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,23,26.2,24.7,26.2,26.7C26.2,26.7,26.2,26.7,26.2,26.7M59.8,3.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-0.8,0-1.5,0.3-2.1,0.7l0,0C53.6,1,53.2,1.4,53,1.9c0,0-0.1,0.1-0.1,0.1c-0.3,0.5-0.4,1.1-0.4,1.6l0,0c0,2,1.6,3.7,3.7,3.7C58.1,7.3,59.8,5.7,59.8,3.7 M26.2,118.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,115.1,26.2,116.8,26.2,118.8C26.2,118.8,26.2,118.8,26.2,118.8 M26.2,141.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,138.2,26.2,139.8,26.2,141.8 M26.2,49.7c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,46.1,26.2,47.7,26.2,49.7C26.2,49.7,26.2,49.7,26.2,49.7M26.2,95.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,92.1,26.2,93.7,26.2,95.8 M157.6,48.3c-0.8,1.9,0.1,4,2,4.8c0.5,0.2,0.9,0.3,1.4,0.3c0.5,0,0.9-0.1,1.4-0.3c0.3-0.1,0.5-0.3,0.8-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.6,1.1-1.4,1.2-2.3v0l0,0c0-0.1,0.1-0.3,0.1-0.4c0-1.2-0.6-2.3-1.6-2.9l0,0c-0.3-0.2-0.6-0.4-0.9-0.5c-0.4-0.2-0.8-0.2-1.2-0.2h0C159.5,46.1,158.2,46.9,157.6,48.3 M26.2,72.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C27.9,69.1,26.2,70.7,26.2,72.7 M157.6,117.4c-0.8,1.9,0.1,4,1.9,4.8c0.5,0.2,0.9,0.3,1.4,0.3h0c0.6,0,1.1-0.1,1.6-0.4l0,0c1.3-0.6,2.1-1.9,2.1-3.3c0-0.3-0.1-0.6-0.2-1l0,0l0,0c-0.1-0.4-0.2-0.7-0.4-1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.4-0.5-0.6-0.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.4-0.2-0.8-0.3-1.3-0.3h0C159.5,115.1,158.2,116,157.6,117.4 M157.3,72.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C159,69.1,157.3,70.7,157.3,72.8 M157.3,95.8c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C159,92.1,157.3,93.8,157.3,95.8 M131.1,72.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,69.1,131.1,70.7,131.1,72.7 M112.2,3.7c0-2-1.6-3.7-3.6-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7C110.6,7.3,112.2,5.7,112.2,3.7 M112.2,49.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7C110.6,53.4,112.2,51.7,112.2,49.7 M112.2,26.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7C110.6,30.4,112.2,28.7,112.2,26.7 M131.1,118.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,115.1,131.1,116.8,131.1,118.8 M131.1,95.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,92.1,131.1,93.7,131.1,95.8 M131.1,26.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,23,131.1,24.7,131.1,26.7 M112.2,72.7c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7C110.6,76.4,112.2,74.8,112.2,72.7 M131.1,141.8c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,138.2,131.1,139.8,131.1,141.8 M131.1,49.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7h0C132.7,46.1,131.1,47.7,131.1,49.7 M0,118.8c0,2,1.6,3.7,3.7,3.7c0.1,0,0.2,0,0.3-0.1l0,0h0c0.9-0.1,1.8-0.5,2.4-1.1c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.4-0.5,0.5-0.8c0.2-0.4,0.3-0.9,0.3-1.4c0-2-1.6-3.7-3.7-3.7c0,0,0,0,0,0h0c-0.1,0-0.1,0-0.2,0c-0.4,0-0.8,0.1-1.2,0.2C0.9,116,0,117.3,0,118.8 M52.4,164.8L52.4,164.8c0,0.4,0.1,0.8,0.2,1.1c0.5,1.5,1.9,2.6,3.4,2.6c0.5,0,1-0.1,1.5-0.3c0.4-0.2,0.7-0.4,1-0.7c0.3-0.3,0.6-0.7,0.8-1c0.1-0.1,0.1-0.2,0.2-0.4c0.2-0.4,0.3-0.8,0.3-1.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.9-0.4-1.7-1-2.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.6-0.5-1.4-0.8-2.2-0.8h0C54.1,161.2,52.4,162.8,52.4,164.8"/></g></g></g>';
      if (n % 5 == 0) {
        // temp = temp  +  text + raster; - dodan raster
        temp = temp + text;
      } else {
        temp = temp + text;
      }
      n++;
    }
    var svg =
      '<svg id="svg" xmlns="http://www.w3.org/2000/svg"> ' + temp + "</svg>";
    $(svg).appendTo(".krugovi");
    var tl1 = gsap.timeline();
    var krugovi = document.querySelectorAll(".krugovi1, .krugovi");
    if (krugovi.length) {
      tl1.to(krugovi, {
        opacity: 1,
        duration: 0.1,
        x: 100,
        stagger: 0.1,
      });
    }
    // var raster = document.querySelectorAll('#raster');
    // tl1.set(raster, {transformOrigin:"50% 50%"})
    // tl1.to(raster, 100, {rotation: "+=1800", repeat: -1})
    // console.log(krugovi);
  }

  // $(window).load(function() {
  // 	krugovi();
  // });

  // Krugovi

  // Animiranje krugova

  $(window).load(function () {
    function krugovi_animacija() {
      var brojKruga = 0;
      var vrijeme = 3000;
      var fillOpacity = 0;

      // for (var i = 0; i < numberOfCircles; i++) {
      setInterval(function () {
        brojKruga = Math.floor(Math.random() * (100 - 1) + 1);
        fillOpacity = Math.random() * (0.5 - 0.1) + 0.1;
        xP = Math.floor(Math.random() * (1920 - 100 + 1) + 100);
        yP = Math.floor(Math.random() * (1920 - 100 + 1) + 100);
        $(".krug" + brojKruga).animate({
          cx: +xP,
          cy: +yP,
        });
      }, vrijeme);
      // }
    }
    krugovi_animacija();
  });

  // Animiranje krugova

  // Kursor

  // Otvaranje slika sa fancyboxom

  
  function dodaj_fancybox() {
    if ($(".fancybox a").length) {
      $(".fancybox a").attr("data-barba-prevent", "self");
      $(".fancybox a").attr("data-fancybox", "gallery");
      console.log("Dodaj_fancy_box")
    }}

  dodaj_fancybox();  

  // Kod za reinicijalizaciju Contact form 7

  function initContactForm_new() {
    var cf_selector = 'div.wpcf7 > form';
    var cf_forms = $("body").find(cf_selector);
     if (cf_forms.length>0) {
     $(cf_selector).each(function() {
      var $form = $(this);
      wpcf7.init( $form[0] ); 
    });
  }}


  // AJAX poziv za imena

  function ajax_poziv() {
    console.log("Ajax učitan");

    var value;
    var gumb;

    $(".trazi-ime").on("click", function (event) {
      // console.log(event);
      value = $(this).attr("ID");
      gumb = $(event.target);
      // console.log(value);
      $(".trazi-ime").removeClass("trenutno");
      //  $('#loader').show();

      jQuery.ajax({
        url: ajaxurl,
        cache: false,
        data: {
          action: "imena",
          vrijednost: value,
        },

        beforeSend: function () {
          // $('#post-dio').fadeOut('fast');
          // $('#plovilo-sadrzaj').replaceWith("<div id='plovilo-sadrzaj'></div>");
          // $('#ucitaj_vise').prop("disabled", true);
          //  $('#loader').show();
        },

        complete: function () {
          //   $('#loader').hide();;
        },

        success: function (response) {
          $("#imena-macica").replaceWith(response);

          // $('.ime').hover (function() {
          //    $('.ime').addClass('zoom');
          //   }, function() {
          //   $('.ime').removeClass('zoom');
          // });
          // console.log(value);

          $(gumb).addClass("trenutno");
        },

        error: function (exception) {
          alert("Exeption:" + exception);
        },

        type: "POST",
      });

      event.preventDefault();
    });
  }

  // Filtriranje vodiča na stranici Savjeti.
  // Koristi nativne gumbe i hidden atribut kako bi radilo i s tipkovnicom
  // te ostalo jednostavno za kasnije ručno održavanje.
  function initSavjetiFilters() {
    var root = document.querySelector("[data-savjeti-root]");

    if (!root || root.dataset.savjetiReady === "true") {
      return;
    }

    root.dataset.savjetiReady = "true";

    var buttons = Array.prototype.slice.call(
      root.querySelectorAll("[data-savjeti-filter]")
    );
    var cards = Array.prototype.slice.call(
      root.querySelectorAll("[data-savjeti-card]")
    );
    var status = root.querySelector("[data-savjeti-status]");
    var empty = root.querySelector("[data-savjeti-empty]");

    if (!buttons.length || !cards.length) {
      return;
    }

    function applySavjetiFilter(slug) {
      var visibleCount = 0;

      buttons.forEach(function (button) {
        var isActive = button.dataset.savjetiFilter === slug;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      cards.forEach(function (card) {
        var topics = (card.dataset.savjetiTopics || "")
          .split(/\s+/)
          .filter(Boolean);
        var shouldShow = slug === "all" || topics.indexOf(slug) !== -1;

        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      if (empty) {
        empty.hidden = visibleCount !== 0;
      }

      if (status) {
        var singularStatus = root.getAttribute("data-filter-status-singular") || "Prikazan je 1 savjet.";
        var pluralStatus = root.getAttribute("data-filter-status-plural") || "Prikazano je %d savjeta.";
        status.textContent = visibleCount === 1
          ? singularStatus
          : pluralStatus.replace("%d", visibleCount);
      }
    }

    function getRequestedSavjetiFilter() {
      var params = new URLSearchParams(window.location.search);
      var requested = params.get("tema") || "all";
      var exists = buttons.some(function (button) {
        return button.dataset.savjetiFilter === requested;
      });

      return exists ? requested : "all";
    }

    function updateSavjetiFilterUrl(slug) {
      if (!window.history || !window.history.replaceState) {
        return;
      }

      var url = new URL(window.location.href);

      if (slug === "all") {
        url.searchParams.delete("tema");
      } else {
        url.searchParams.set("tema", slug);
      }

      url.hash = "savjeti-teme";
      window.history.replaceState({}, "", url.toString());
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var slug = button.dataset.savjetiFilter || "all";
        applySavjetiFilter(slug);
        updateSavjetiFilterUrl(slug);
      });
    });

    applySavjetiFilter(getRequestedSavjetiFilter());
  }

  // Filtriranje članaka na glavnoj stranici Opreme za mačke.
  // Kategorije s jednim člankom ostaju obične poveznice, dok kategorije
  // s više članaka dobivaju isti brzi filter kao teme na stranici Savjeti.
  function initEquipmentFilters() {
    var root = document.querySelector("[data-equipment-root]");

    if (!root || root.dataset.equipmentReady === "true") {
      return;
    }

    root.dataset.equipmentReady = "true";

    var controls = Array.prototype.slice.call(
      root.querySelectorAll("[data-equipment-filter]")
    );
    var cards = Array.prototype.slice.call(
      root.querySelectorAll("[data-equipment-card]")
    );
    var status = root.querySelector("[data-equipment-status]");
    var empty = root.querySelector("[data-equipment-empty]");

    if (!controls.length || !cards.length) {
      return;
    }

    function applyEquipmentFilter(slug) {
      var visibleCount = 0;

      controls.forEach(function (control) {
        var isActive = control.dataset.equipmentFilter === slug;
        control.classList.toggle("is-active", isActive);
        control.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      cards.forEach(function (card) {
        var categories = (card.dataset.equipmentCategories || "")
          .split(/\s+/)
          .filter(Boolean);
        var shouldShow = slug === "all" || categories.indexOf(slug) !== -1;

        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      if (empty) {
        empty.hidden = visibleCount !== 0;
      }

      if (status) {
        var singularStatus = root.getAttribute("data-filter-status-singular") || "Prikazan je 1 članak.";
        var pluralStatus = root.getAttribute("data-filter-status-plural") || "Prikazano je %d članaka.";
        status.textContent = visibleCount === 1
          ? singularStatus
          : pluralStatus.replace("%d", visibleCount);
      }
    }

    controls.forEach(function (control) {
      control.addEventListener("click", function (event) {
        event.preventDefault();
        applyEquipmentFilter(control.dataset.equipmentFilter || "all");
      });
    });

    applyEquipmentFilter("all");
  }

  initSavjetiFilters();
  initEquipmentFilters();
});
